import {
  WcDataGrid,
  WcGridColDef,
  WcGridRowSelectionModel,
} from "@bpipartners/datagrid";
import { CandidatesByActivityTypeIDsAndDateRow } from "@cbex/data-access";
import { useWindowDimensions } from "@cbex/utils/hooks";
import { Button, Paper, Stack } from "@mui/material";
import { useTranslations } from "next-intl";
import React from "react";

interface ImportCandidatesDetailsProps {
  data: CandidatesByActivityTypeIDsAndDateRow[];
  onImportClick: (candidates: CandidatesByActivityTypeIDsAndDateRow[]) => void;
}

export const ImportCandidatesDetails = ({
  data,
  onImportClick,
}: ImportCandidatesDetailsProps) => {
  const t = useTranslations();
  const [candidateData, setCandidateData] = React.useState([]);
  const { height } = useWindowDimensions();
  React.useEffect(() => {
    if (data && data.length > 0) {
      setCandidateData(data);
    }
  }, [data]);

  const [selectedRowsState, setSelectedRowsState] =
    React.useState<WcGridRowSelectionModel>({
      type: "include",
      ids: new Set(),
    });
  const candidateColumnData: WcGridColDef[] = [
    {
      field: "startDate",
      headerName: t("labels.startDate"),
      type: "date",
      valueGetter: (value) => value && new Date(value),
    },
    {
      field: "activityName",
      headerName: t("labels.activity"),
      width: 200,
      valueGetter: (value, row) => row.activityName,
    },
    {
      field: "initials",
      headerName: t("labels.initials"),

      valueGetter: (value) => value,
    },
    {
      field: "infix",
      headerName: t("labels.infix"),
      width: 150,
      valueGetter: (value) => value,
    },
    {
      field: "lastName",
      headerName: t("labels.lastName"),
      width: 150,

      sortable: true,
      valueGetter: (value) => value,
      editable: false,
    },
    {
      field: "dateOfBirth",
      width: 200,
      headerName: t("labels.dob"),
      type: "date",
      valueGetter: (value) => value && new Date(value),
    },
    {
      field: "emailAddress",
      headerName: t("labels.email"),
      valueGetter: (value) => value,
    },
  ];

  const handleCheckBoxSelection = (model: WcGridRowSelectionModel) => {
    setSelectedRowsState(model);
  };

  const handleImportClick = () => {
    const getCandidates = candidateData.filter((candidateItem) =>
      Array.from(selectedRowsState.ids).includes(candidateItem.candidateID)
    );
    onImportClick(getCandidates);
  };

  return (
    <Stack id="ImportCandidatesDetails">
      <Stack p={1} spacing={2} alignItems={"flex-end"}>
        {selectedRowsState.ids.size > 0 && (
          <Button
            fullWidth={false}
            sx={{ width: 250 }}
            onClick={handleImportClick}
            variant="contained"
          >
            {t("labels.addCandidates")}
          </Button>
        )}
      </Stack>

      <Paper>
        {candidateData && (
          <Stack height={height - 300} width={"100%"}>
            <WcDataGrid
              getCustomID={(row) => row.candidateID}
              checkboxSelection={true}
              disableRowSelectionExcludeModel
              initialState={{
                columns: {
                  columnVisibilityModel: {
                    candidateID: false,
                  },
                },
              }}
              columns={candidateColumnData}
              showQuickFilter={true}
              onRowSelectionModelChange={(newRowSelectionModel) => {
                handleCheckBoxSelection(newRowSelectionModel);
              }}
              rowSelectionModel={selectedRowsState}
              density="compact"
              rowHeight={60}
              rows={candidateData}
            />
          </Stack>
        )}
      </Paper>
    </Stack>
  );
};

export default ImportCandidatesDetails;
